"use client";

import { DollarSign } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function CurrencyExchangeSavings() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="py-16 px-4 bg-background">
      <div className="max-w-4xl mx-auto">
        <div ref={ref} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="border-primary/20 shadow-medium hover:shadow-strong hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] px-6">
            <CardHeader className="pb-4">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary-light-background flex items-center justify-center">
                  <DollarSign className="w-6 h-6 text-primary" />
                </div>
                <CardTitle className="text-2xl md:text-3xl font-display text-foreground leading-tight">
                  Save More with Canadian Dollar Pricing
                </CardTitle>
              </div>
            </CardHeader>
            <CardContent className="space-y-6">
              <p className="text-base md:text-lg text-foreground/80 leading-relaxed">US companies benefit from favorable currency exchange rates when paying in Canadian dollars. With all GP2BC Express services priced in CAD starting at $7,500, American businesses can realize significant cost savings on their Microsoft Dynamics GP to Business Central migration—all while receiving the same precision, audit-ready results, and professional service.</p>
              <div className="flex flex-col sm:flex-row gap-4 pt-2">
                <Link to="#currency-savings">
                  <Button className="btn-primary w-full sm:w-auto">
                    Learn More
                  </Button>
                </Link>
                <Link to="/ContactPage">
                  <Button variant="outline" className="w-full sm:w-auto border-primary/30 text-primary hover:bg-primary-light-background hover:border-primary/50 transition-all duration-[var(--duration-fast)]">
                    Contact Us
                  </Button>
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}